/* eslint-disable react/no-array-index-key */
import React from 'react';
import AwesomeSlider from 'react-awesome-slider';

import PropTypes from 'prop-types';

import 'react-awesome-slider/dist/styles.css';
import './styles.css';
import { ImageSlice } from './styles';

export default function SliderImage({ images }) {
  return (
    <AwesomeSlider>
      {images.map((image, index) => (
        <div key={image.description}>
          <ImageSlice key={index} image={image.url} />
        </div>
      ))}
    </AwesomeSlider>
  );
}

SliderImage.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
